import api from './api_client';

export const jobOfferService = {
  create: async (data) => {
    const response = await api.post('/recruitment/job-offers', data);
    return response.data;
  },

  getAll: async (params = {}) => {
    const response = await api.get('/recruitment/job-offers', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/recruitment/job-offers/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/recruitment/job-offers/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/recruitment/job-offers/${id}`);
    return response.data;
  },

  close: async (id) => {
    const response = await api.patch(`/recruitment/job-offers/${id}/close`);
    return response.data;
  },

  reopen: async (id) => {
    const response = await api.patch(`/recruitment/job-offers/${id}/reopen`);
    return response.data;
  }
};

export default jobOfferService;
